<template>
    <div class='t_content_view'>
        <el-page-header @back="goBack" content="发送详情" />
        <div class="t_add_title">
            群发信息
        </div>
        <div>
            <!-- <div class="t_send_detail" >创建成员：{{ detaillist.data.createName }}</div> -->
            <div class="t_send_detail" >任务名称：{{ detaillist.data.title }}</div>
            <div class="t_send_detail" >执行时间：{{ detaillist.data.execute_at }}</div>
            
            <div class="t_send_detail" >任务状态：
                <span v-if="detaillist.data.status==0">待执行</span>
                <span v-if="detaillist.data.status==10">执行中</span>
                <span v-if="detaillist.data.status==20">执行完毕</span>
                <span v-if="detaillist.data.status==25">已暂停</span>
                <span v-if="detaillist.data.status==-10">执行异常终止</span>
                <span v-if="detaillist.data.status==-20">执行完毕存在异常</span>
                <span v-if="detaillist.data.status==-30">已过期</span>
            </div>
            <!-- <div class="t_send_detail" >群发对象：
                <span v-if='detaillist.data.conditionVo==null'>全部成员</span>
                <el-button v-else type="text" @click="opendialog(detaillist.data.conditionVo)" style="color:#4F46E5" >查看</el-button>
            </div> -->
            <div class="t_send_detail" >已发送客户：{{ detaillist.data.sent_amount }}</div>
            <div class="t_send_detail" >群发内容：
                <div v-for="(item,index) in sendcontent.data" :key="index" class="t_send_content_item">
                    <div v-if="item.msg_type=='Text'" class="t_send_content_text">{{ decode(item.content) }}</div>
                    <template v-else-if="item.msg_type=='Link'">
                        <div class="t_send_content_text">{{ item.jcontent.title }}</div>
                        <div class="t_send_content_desc">{{ item.jcontent.desc }}</div>
                        <div class="t_send_content_desc">{{ item.jcontent.url }}</div>
                    </template>
                    <video v-else-if="item.msg_type=='Video'" :src="decode(item.content)" controls class="t_send_content_video"></video>
                    <img v-else-if="item.msg_type=='Picture'" :src="decode(item.content)" class="t_send_content_img" alt="">
                </div>
            </div>
        </div>
        <div class="t_add_title" style="display:flex;justify-content:space-between;align-items:center;">
            群发记录
            <el-button type="primary" size="small" @click="exportlist">导出明细</el-button>
        </div>
        <div class="t_search_box">
            <div class="t_search_select" >
                <img src="../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input @input="searchinput" size="small" v-model="searchdata.external_name" placeholder="请输入客户微信名"  clearable />
            </div>
            <div class="t_search_select" >
                <img src="../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input @input="searchkfNameinput" size="small" v-model="searchdata.internal_name" placeholder="请输入客服微信名"  clearable />
            </div>
            
            <!-- <div class="t_search_select" style="margin-right:20px;margin-left:20px">
                <span style="color: #6D6D6D;">执行扫码号：</span>
                <el-select size="small"
                @change="searchselect"
                v-model="searchdata.state" clearable placeholder="请选择">
                    <el-option v-for="item in options.data" :key="item.id" :label="item.title" :value="item.id" />
                </el-select>
            </div> -->
            <div class="t_search_select">
                <span style="color: #6D6D6D;">发送状态：</span>
                <el-select size="small"
                style="width: 180px;"
                @change="searchselect"
                v-model="searchdata.status" clearable placeholder="请选择">
                    <el-option v-for="item in options.data" :key="item.id" :label="item.title" :value="item.id" />
                </el-select>
            </div>
            <!-- <div class="t_search_select" style="margin-right:20px;margin-left:20px">
                <span style="color: #6D6D6D;">发送结果：</span>
                <el-select size="small"
                @change="searchselect"
                v-model="searchdata.state" clearable placeholder="请选择">
                    <el-option v-for="item in options.data" :key="item.id" :label="item.title" :value="item.id" />
                </el-select>
            </div> -->
            <div class="t_search_select" >
                <span style="color: #6D6D6D;">发送时间：</span>
                <el-date-picker
                    size="small" 
                    @change="changeTime"
                    v-model="choosetime.data"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                />
            </div>
            
        </div>
        <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data" style="width: 100%;margin-top: 20px;">
            <el-table-column prop="external_name" label="客户信息" />
            <el-table-column prop="internal_name" label="客服微信名"  />
            <el-table-column prop="address" label="发送状态" >
                <template #default="scope">
                    <span v-if="scope.row.status==0">待执行</span>
                    <span v-if="scope.row.status==5">待设备补发</span>
                    <span v-if="scope.row.status==10">已下发待回执</span>
                    <span v-if="scope.row.status==20">发送成功</span>
                    <span v-if="scope.row.status==-20">发送失败</span>
                    <span v-if="scope.row.status==-30">无可发送关系</span>
                    <span v-if="scope.row.status==-40">已过期</span>
                    <span v-if="scope.row.status==-50">设备离线发送失败</span>
                </template>
            </el-table-column>
            <el-table-column prop="sent_at" label="发送时间" />
            <!-- <el-table-column prop="address" label="任务状态" >
                <template #default="scope">
                    <span v-if="scope.row.state==1">开启中</span>
                    <span v-if="scope.row.state==0">已完成</span>
                </template>
            </el-table-column> -->
            <el-table-column prop="send_err_msg" label="发送失败原因" >
                <template #default="scope">
                    <span>{{ scope.row.send_err_msg || '' }}</span>
                </template>
            </el-table-column>
        </el-table> 
        <!-- 分页 -->
        <pagechange :total="total" :nowpage="searchdata.page" @page_change="page_change" />
    </div>
    <!-- 详情弹窗 -->
    <el-dialog
        v-model="detailshow"
        title="按条件筛选方式"
        width="500px">
        <div class="t_add_title" style="margin-top: 0;padding-bottom: 10px;border-bottom:1px dashed #d3d3d3">
            群发记录
        </div>
        <!-- <div class="t_detail_item">
            <div class="t_detail_item_title">客户性别：</div>
            <div class="t_detail_tiem_con">{{ shai.data.gender }}</div>
        </div> -->
        <div class="t_detail_item">
            <div class="t_detail_item_title">添加客户日期：</div>
            <div class="t_detail_tiem_con" v-if="shai.data.startTime==''" >全部</div>
            <div v-else class="t_detail_tiem_con">
                <span v-if="shai.data.isExit=='1'">排除条件：</span>
                {{ shai.data.startTime }} 至 {{ shai.data.endTime }}
            </div>
        </div>
        <div class="t_detail_item">
            <div class="t_detail_item_title">客户所属渠道：</div>
            <div v-if="shai.data.quDaoIds[0]==''" class="t_detail_tiem_con">全部</div>
            <div v-else>
                <span v-if="shai.data.isExit=='1'">排除条件：</span>
                <div v-for="(item,index) in shai.data.quDaoIds" :key="index">{{ fanyi_qd(item) }}</div>
            </div>
        </div>
        <div class="t_detail_item">
            <div class="t_detail_item_title">客户标签：满足任意一个标签</div>
            <div class="t_detail_tiem_con">
                <div v-if="shai.data.tagIds[0]==''" class="t_detail_tiem_con">全部</div>
                <div v-else>
                    <span v-if="shai.data.isExit=='1'">排除条件：</span>
                    <el-tag v-for="(item,index) in shai.data.tagIds" :key="index" size="small" style="margin-right: 5px;" type="success">{{ fanyi_tag(item) }}</el-tag>
                </div>
                
            </div>
        </div>
    </el-dialog>
</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { ElMessage,ElMessageBox } from 'element-plus'
import { Delete, Edit, Search, Share, Upload ,Plus ,Close} from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { allsenditem,itemsendlist,bqlist,qdmlist,newgetallsenditem,newgetallsenduser,newexportallsenduser } from '@/assets/js/common.js'
import { decode } from '@/assets/js/base64.js'
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()
const goBack = () => {
    router.push({ path: '/navxxcd/allsendmsg' })
}
//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    console.log('onMounted')
    //获取标签列表
    // getbqlist()
    //获取所有渠道下拉
    // getallqdlist()
    //消息详情
    getdetail()
    getlist()
})
//详情数据
const detaillist = reactive({
    data:{}
})
//群发内容
const sendcontent = reactive({
    data:[]
})
//消息详情
const getdetail = ()=>{
    newgetallsenditem({id:route.query.id}).then((response)=>{
        console.log('详情')
        console.log(response.data)
        // 假数据
        // response.data.result.conditionVo = JSON.parse(response.data.result.conditionVo)

        detaillist.data = response.data.data
        sendcontent.data = JSON.parse(response.data.data.content || '[]').map((item)=>{
            // 网页类型的 content 是 base64 后的 jcontent JSON
            if(item.msg_type=='Link'){
                item.jcontent = JSON.parse(decode(item.content))
            }
            return item
        })
        
        console.log(detaillist.data)
    })
    
}
//搜索内容
const searchdata  = reactive({
    // name:'',
    // zuoxi:'',
    // status:'',
    // executeTimeStart:'',
    // executeTimeEnd:'',
    // messageId:route.query.id,
    page:1,
    page_size:20,
    status:'',
    task_id:route.query.id,
    external_name:'',
    internal_name:'',
    sent_at_start:''
    
})
//监听搜索客户名称内容变化
const searchinput = (e)=>{
    console.log(e)
    searchdata.name = e
    searchdata.page=1
    getlist()
}
//监听搜索扫码号内容变化
const searchkfNameinput = (e)=>{
    console.log(e)
    searchdata.zuoxi = e
    searchdata.page=1
    getlist()
}
//搜索框下拉
const options = reactive({
    data:[
    {
        id:0,
        title:'待执行'
      },
      {
        id:5,
        title:'待设备补发'
      },
      {
        id:10,
        title:'已下发待回执'
      },
      {
        id:20,
        title:'发送成功'
      },
      {
        id:-20,
        title:'发送失败'
      },
      {
        id:-30,
        title:'无可发送关系'
      },
      {
        id:-40,
        title:'已过期'
      },
      {
        id:-50,
        title:'设备离线发送失败'
      }
    ]
})
//监听搜索下拉变化
const searchselect = (e)=>{
    console.log(e)
    searchdata.state = e
    searchdata.page=1
    getlist()
}
//搜索时间
const choosetime = reactive({
    data:[]
})
//监听时间改变
const changeTime = (e)=>{
    console.log(e)
    if(e==null){
        searchdata.sent_at_start = ''
        searchdata.sent_at_end = ''
    }else{
        searchdata.sent_at_start = e[0]
        searchdata.sent_at_end = e[1]
    }
    searchdata.page=1
    getlist()
}

//列表数据
const tableData = reactive({
    data:[]
})
//获取列表
const getlist = ()=>{
    newgetallsenduser(searchdata).then((response)=>{
        // for(var x = 0;x<response.data.result.records.length;x++){
        //     var jsoncarr = response.data.result.records[x].jsonContent.split('&&')
        //     var arr = []
        //     for(var y = 0;y<jsoncarr.length;y++){
        //         arr.push(JSON.parse(jsoncarr[y]))
        //     }
        //     response.data.result.records[x].jsonContentarr=arr
        // }
        console.log('发送用户')
        console.log(response.data)
        tableData.data = response.data.data.data
        total.value = response.data.data.total
        
    })
}
//成员总数
const total = ref(0)
//监听分页
const page_change = (val)=>{
    searchdata.page = val
    //人员列表
    getlist()
}
//导出明细
const exportlist = ()=>{
    newexportallsenduser({
        task_id: route.query.id,
        status: searchdata.status || ''
    }).then((response)=>{
        if(response.data.msg.code==0){
            const a = document.createElement('a');
            a.setAttribute('download', '');
            a.setAttribute('href', response.data.data);
            a.click();
        }
    })
}
//详情弹窗
const detailshow = ref(false)
//弹窗数据
const shai = reactive({
    data:{}
})
//打开弹窗
const opendialog = (row,gender)=>{
    
    shai.data = JSON.parse(JSON.stringify(row));
    shai.data.quDaoIds = shai.data.quDaoIds.split(',')
    shai.data.tagIds = shai.data.tagIds.split(',')
    console.log(shai.data)
    detailshow.value = true
}

// 全部标签
const bqData = reactive({
    data:[]
})
//获取标签列表
const getbqlist = ()=>{
    bqlist(_url2).then((response)=>{
        console.log('标签')
        console.log(response)
        if (response.data.msg.code == 0) {
            bqData.data = response.data.result
            
            //添加是否选中状态
            for(var i=0;i<bqData.data.length;i++){
                for(var x=0;x<bqData.data[i].tagList.length;x++){
                    bqData.data[i].tagList[x].checked=false
                }
            }
            console.log('全部标签')
            console.log(bqData.data)
        }
    })
}
//翻译标签
const fanyi_tag = (id)=>{
    for(var x= 0;x<bqData.data.length;x++){
        for(var y=0;y<bqData.data[x].tagList.length;y++){
            if(bqData.data[x].tagList[y].id == id){
                return bqData.data[x].tagList[y].title
            }
        }
    }
}
//所有渠道下拉
const allqdlist = reactive({
    data:[]
})
//获取所有渠道下拉
const getallqdlist = ()=>{
    qdmlist(_url2,{ page:1,
    page_size:200000,
    title:'',
    categoryId:''}).then((response)=>{
        if (response.data.msg.code == 0) {
            
            allqdlist.data = response.data.result.records
            console.log('渠道下拉')
            console.log(allqdlist.data)
        }
    })
}
//翻译渠道
const fanyi_qd = (id)=>{
    for(var x= 0;x<allqdlist.data.length;x++){
        if(allqdlist.data[x].id==id){
            return allqdlist.data[x].title
        }
    }
}




</script>
<style scoped>


:deep(.t_search_select .select-trigger) {
    width:100%
}

:deep(.t_search_box .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
.t_send_detail{
    color: #747474;
    font-size: 15px;
    margin-top: 30px;
    margin-bottom: 30px;
    box-sizing: border-box;
    padding-left: 30px;
}
.t_detail_item_title{
    font-size: 14px;
    color: #747474;
}
.t_detail_tiem_con{
    font-size: 15px;
    margin-top: 5px;
    color: black;
}
.t_detail_item{
    margin-bottom: 15px;
}
.t_send_content_item{
    margin-bottom: 10px;
}
.t_send_content_text{
    color: black;
    font-size: 15px;
    line-height: 22px;
    white-space: pre-wrap;
    word-break: break-all;
}
.t_send_content_desc{
    color: #747474;
    font-size: 14px;
    line-height: 20px;
    margin-top: 4px;
    word-break: break-all;
}
.t_send_content_video{
    width: 320px;
    max-width: 100%;
}
.t_send_content_img{
    width: 120px;
}
:deep(.t_search_select .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
</style>